import {
  ACCESS_ACTION_ADD_BUTTON,
  ACCESS_DEMPOINT_ACTIVATE_DEACTIVATE_BUTTON,
  ACCESS_DEMPOINT_ADD_EDIT_NOTE_BUTTON
} from '../../data/constants/authConstants';
import {
  ACTIVATE_DEACTIVATE_DEMPOINT_BUTTON_TYPE_NAME,
  SHOW_COORDS_ON_MAP_BUTTON_TYPE_NAME,
  ADD_ACTION_TO_DEMPOINT_BUTTON_TYPE_NAME
} from '../../data/constants/buttonsNamesConstants';
import { isDemPointSingle } from '../demPointsHelper.js';
import snippets from '../htmlSnippets/actionsTooltipSnippets.js';
import { getCopyToClipboardButton } from '../htmlSnippets/tooltipSnippets.js';

export function getCreatedDemPointMarkerTooltip(
  lat,
  lon,
  demPoint,
  authStore,
  hideOperationalButtons
) {
  const addActionToDemPointButton =
    authStore.canAccess(ACCESS_ACTION_ADD_BUTTON) &&
    !hideOperationalButtons &&
    isDemPointSingle(demPoint)
      ? `<button clickable type='button' class='btn btn-outline btn-info btn-xs' id='${ADD_ACTION_TO_DEMPOINT_BUTTON_TYPE_NAME}:${demPoint?.id}' id_demPoint='${demPoint?.id}' click_action_type='${ADD_ACTION_TO_DEMPOINT_BUTTON_TYPE_NAME}'>Dodaj akcję</button>`
      : '';

  const toggleDemPointButton =
    authStore.canAccess(ACCESS_DEMPOINT_ACTIVATE_DEACTIVATE_BUTTON) && !hideOperationalButtons
      ? `<button clickable type='button' class='btn btn-outline btn-info btn-xs' id='${ACTIVATE_DEACTIVATE_DEMPOINT_BUTTON_TYPE_NAME}:${
          demPoint?.id
        }' id_demPoint='${
          demPoint?.id
        }' click_action_type='${ACTIVATE_DEACTIVATE_DEMPOINT_BUTTON_TYPE_NAME}' demPoint_add_action_allowed='${
          demPoint.add_action_allowed
        }'>${demPoint.add_action_allowed == 1 ? 'Dezaktywuj' : 'Aktywuj'}</button>`
      : '';

  const addEditNoteButton =
    authStore.canAccess(ACCESS_DEMPOINT_ADD_EDIT_NOTE_BUTTON) && !hideOperationalButtons
      ? snippets.addEditDemPointNoteButtonSnippet(demPoint)
      : '';

  const showDuplicatesButton =
    !hideOperationalButtons && demPoint?.warning_marker === 1
      ? snippets.showDuplicatesButtonSnippet(demPoint)
      : '';

  let coordsSection = `<div>${lat}, ${lon} ${getCopyToClipboardButton(
    demPoint?.id,
    `lat='${lat}' lon='${lon}'`
  )}`;
  coordsSection += `<button clickable type='button' class="btn btn-white btn-xs ml-1" id='${SHOW_COORDS_ON_MAP_BUTTON_TYPE_NAME}:${demPoint?.id}' lat='${lat}' lon='${lon}' click_action_type='${SHOW_COORDS_ON_MAP_BUTTON_TYPE_NAME}'><i class="fa fa-google" clickable_child></i></button>`;
  coordsSection += '</div>';
  const tag = demPoint?.oznaczenie ? '<b>' + demPoint?.oznaczenie + '</b>' : '';
  const copyTagButton =
    tag === ''
      ? ''
      : getCopyToClipboardButton(`${demPoint?.id}:tag`, `tag='${demPoint.oznaczenie}'`);
  const tagSection = '<div>' + tag + copyTagButton + '</div>';

  const xid = demPoint?.xid ? '<b>' + demPoint?.xid + '</b>' : '';
  const copyXidButton =
    xid === '' ? '' : getCopyToClipboardButton(`${demPoint?.id}:xid`, `xid='${demPoint.xid}'`);
  const xidSection = '<div>' + xid + copyXidButton + '</div>';

  let noteSection = demPoint.note ? `<div>Uwagi: <i>${demPoint.note}</i></div>` : '';

  const buttonsSection =
    toggleDemPointButton || addActionToDemPointButton || addEditNoteButton || showDuplicatesButton
      ? `<div class='mt-1' style='display: flex; gap: 5px'>` +
        toggleDemPointButton +
        addActionToDemPointButton +
        addEditNoteButton +
        showDuplicatesButton +
        '</div>'
      : '';

  return (
    '<div style="display: flex; flex-direction: column; gap: 2px">' +
    coordsSection +
    tagSection +
    xidSection +
    noteSection +
    buttonsSection +
    '</div>'
  );
}
